@if (useBack) {
  <button
    inline-button
    leadingIcon="cds-comp:arrow-back"
    class="rail-back m-is-xs"
    (click)="onItemClick($event, 'back')"
    (keydown)="onItemKeyDown($event, 'back')"
    [attr.aria-label]="backLabel"
    tabindex="-1"
    #backButton
    data-cy="btn-navigation-drawer-back"
    >{{ backLabel }}</button
    >
  }

  @if (fabIcon) {
    <button
      fab-button
      [attr.aria-label]="fabLabel"
      [label]="fabLabel"
      [icon]="fabIcon"
      (click)="onItemClick($event, 'fab')"
      (keydown)="onItemKeyDown($event, 'fab')"
      tabindex="-1"
      class="m-is-m"
      #fabButton
    ></button>
  }

  <div
    #itemsContainer
    class="[ stack stack-space-3xs w-full ] [ p-b-s ] [ overflow-y-auto w-full ]"
  [ngClass]="{
    'justify-start': align === 'top',
    'justify-center': align === 'center',
    'justify-end': align === 'bottom',
  }"
    >
    @for (item of items; track trackByLabel($index, item)) {
      <a
        #item
        navigation-drawer-item
        [icon]="item.icon"
        [label]="item.label"
        [selected]="item.selected"
        [badge]="item.badge"
        [menu]="item.menu"
        (mousedown)="onItemClick($event, item)"
        [attr.tabindex]="item.selected ? 0 : -1"
        (focusin)="item.selected && onActiveItemFocus($event, item)"
        (keydown)="onItemKeyDown($event, item)"
        [routerLink]="item.routerLink"
        [queryParams]="item.routerOptions?.queryParams"
        [fragment]="item.routerOptions?.fragment"
        [queryParamsHandling]="item.routerOptions?.queryParamsHandling"
        [preserveFragment]="item.routerOptions?.preserveFragment"
        [skipLocationChange]="item.routerOptions?.skipLocationChange"
        [replaceUrl]="item.routerOptions?.replaceUrl"
        [state]="item.routerOptions?.state"
        [relativeTo]="item.routerOptions?.relativeTo"
        data-cy="navigation-drawer-item"
      ></a>
    }
  </div>

  @if (isHandset$ | async) {
    @if (closed) {
      @if (selectedItem$ | async; as selectedItem) {
        <button class="trigger" (click)="trigger.emit()">
          <campus-icon [svgIcon]="selectedItem.icon"></campus-icon>
          <span class="label-small">{{ selectedItem.label }}</span>
        </button>
      }
    }
  }
